/**
 * @description sets the user's quiz results
 * @param {Object} userAnswers object of user answers to questions
 * @param {String[]} nationalTopics array of national topics
 * @param {String} raceId id of race
 * @param {Function} setUserQuizScores function for setting quiz scores
 * @param {Function} onSuccess function to call when process succeeds
 * @param {Function} onFailure function to call when process fails
 */
async function setResults(userAnswers, nationalTopics, raceId, setUserQuizScores, onSuccess, onFailure) {
  const nationalTopicAnswers = Object.entries(userAnswers).reduce((acc, [field, value]) => ({
    ...acc,
    ...(nationalTopics.includes(field) ? { [field]: value } : {}),
  }), {});

  const raceTopicAnswers = Object.entries(userAnswers).reduce((acc, [field, value]) => ({
    ...acc,
    ...(!nationalTopics.includes(field) ? { [field]: value } : {}),
  }), {});

  setUserQuizScores(nationalTopicAnswers, raceTopicAnswers, raceId, onSuccess, onFailure);
}

/**
 * @description returns default style object for slider
 * @returns {Object} default style object
 */
function getSliderDefaultStyles() {
  return {
    track: {
      backgroundColor: '#F2F9FD',
      width: '100%',
      height: '20px',
      borderRadius: '50px',
    },
    thumb: {
      backgroundColor: '#DB7D77',
      width: '25px',
      height: '25px',
    },
    active: {
      backgroundColor: '#F2F9FD',
    },
  };
}

export {
  getSliderDefaultStyles,
  setResults,
};
